import { render } from "./SelectWallet.vue?vue&type=template&id=13802ed2&scoped=true"
import script from "./SelectWallet.vue?vue&type=script&lang=js"
export * from "./SelectWallet.vue?vue&type=script&lang=js"

import "./SelectWallet.vue?vue&type=style&index=0&id=13802ed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13802ed2"]])

export default __exports__